import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import gradPrograms, { Action as GradProgramAction } from './gradPrograms';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import idealistDayEvents, {
  Action as IdealistDayEventAction,
} from './idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import integrations, { Action as IntegrationsAction } from './integrations';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import listings, { Action as ListingsAction } from './listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import orgs, { Action as OrgAction } from './orgs';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import searchReducer, { Action as SearchAction } from './search';

export type Action =
  | GradProgramAction
  | IdealistDayEventAction
  | ListingsAction
  | OrgAction
  | SearchAction;

// eslint-disable-next-line import/no-default-export
export default combineReducers<
  {
    orgs: typeof orgs;
    listings: typeof listings;
    search: typeof searchReducer;
    gradPrograms: typeof gradPrograms;
    idealistDayEvents: typeof idealistDayEvents;
    integrations: typeof integrations;
  },
  | OrgAction
  | ListingsAction
  | SearchAction
  | GradProgramAction
  | IdealistDayEventAction
  | IntegrationsAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  orgs,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  listings,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  search: searchReducer,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  gradPrograms,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  idealistDayEvents,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  integrations,
});
